module.exports = __webpack_public_path__ + "static/media/story-19.7a8d41b3.jpg";